import React from "react";

export default function AccountIcon({ className = '' }) {
    return (
        <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                d="M16.6244 14.8743L23 10.0529V18.375C23 19.8223 21.7886 21 20.3 21H7.70004C6.21139 21 5 19.8223 5 18.375V10.0529L11.3756 14.8743C12.1478 15.4579 13.0738 15.7502 14 15.7502C14.9262 15.7502 15.8523 15.4579 16.6244 14.8743ZM12.4803 13.4925L5.45129 8.17687C5.93556 7.46905 6.7617 7 7.69961 7H20.2995C21.2384 7 22.0645 7.46905 22.5487 8.17687L15.5198 13.4925C14.6251 14.169 13.3749 14.169 12.4803 13.4925Z"
                fill="#4F6E90" />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M16.6244 14.8214L23 10V18.3221C23 19.7693 21.7886 20.9471 20.3 20.9471H7.70004C6.21139 20.9471 5 19.7693 5 18.3221V10L11.3756 14.8214C12.1478 15.405 13.0738 15.6972 14 15.6972C14.9262 15.6972 15.8523 15.405 16.6244 14.8214Z"
                fill="#8DADD0" />
        </svg>
    );
}
